import React, { FC } from "react";
import { cn } from "helpers/classNames";
interface Props {
  children: React.ReactNode;
  size?: "small" | "medium" | "large";
  isLoading?: boolean;
  loadingText?: string;
  color?: "primary" | "black" | "primarySoft" | "errorSoft";
}

const buttonBaseClass =
  "inline-flex items-center border border-transparent shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:bg-gray-400";

const PrimaryButton: FC<
  Props &
    React.DetailedHTMLProps<
      React.ButtonHTMLAttributes<HTMLButtonElement>,
      HTMLButtonElement
    >
> = ({
  children,
  size = "medium",
  isLoading = false,
  loadingText = "Sparar...",
  color = "primary",
  className,
  ...rest
}) => {
  const getColorClass = (
    color: "primary" | "black" | "primarySoft" | "errorSoft",
  ) => {
    switch (color) {
      case "primary":
        return "text-white bg-cyan-700 hover:bg-cyan-600 focus:ring-cyan-400";
      case "black":
        return "text-white bg-gray-950 hover:bg-gray-700 focus:ring-gray-800";
      case "primarySoft":
        return "bg-cyan-50 text-cyan-700 hover:bg-cyan-100 border border-cyan-100";
      case "errorSoft":
        return "bg-rose-50 text-rose-700 hover:bg-rose-100 border border-rose-100";
    }
  };
  const getClassForSize = (size: "small" | "medium" | "large") => {
    switch (size) {
      case "small":
        return "px-2.5 py-1.5 text-xs font-semibold rounded";
      case "large":
        return "px-4 py-2 text-sm font-semibold rounded-md";
      case "medium":
      default:
        return "px-4 py-2 text-sm leading-4 font-semibold rounded-md";
    }
  };
  return (
    <button
      type="button"
      className={cn(
        buttonBaseClass,
        getColorClass(color),
        getClassForSize(size),
        className,
      )}
      {...rest}
    >
      <div className="mx-auto flex items-center">
        {isLoading && (
          <svg
            className={cn(
              size === "small" ? "h-3 w-3" : "h-5 w-5",
              "-ml-1 mr-3 animate-spin text-white",
            )}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        )}
        {isLoading ? loadingText : <>{children}</>}
      </div>
    </button>
  );
};

export default PrimaryButton;
